import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';

const PricingPanel = ({ title, price, features }) => {
  const featureList = features.map(feature => (
    <li key={feature}>
      <i className="fa-solid fa-check"></i>
      {feature}
    </li>
  ));

  return (
    <div className='bg-white shadow-lg rounded-lg text-gray-800'>
      <div className='px-6 py-8 '>
        <h4 className='text-lg font-semibold mb-2'>{title}</h4>
        <p className='text-gray-600'> </p>
        <p className='text-4xl font-bold text-[#c026d3]'>{price}<sub className='text-xl font-medium'>/month</sub></p>
        <ul className='text-sm mt-8'>
          {featureList}
        </ul>
        <button className='bg-[#c026d3] text-white font-semibold py-2 px-4 mt-8 rounded hover:bg-green-600'>SELECT</button>
      </div>
    </div>
  );
};


const Pricing = () => {
  const pricingData = [
    {
      title: 'BASIC',
      price: '$2',
      features: [
        '1 domain name',
        '10 GB of disk space',
        '100GB of bandwidth',
        '1 MySQL database',
        '5 email accounts',
        'cPanel control panel',
        'Free SSL certificate',
        '24/7 support',
      ],
    },
    {
      title: 'STANDARD',
      price: '$5',
      features: [
        'Unlimited domain name',
        '50 GB of disk space',
        '500GB of bandwidth',
        '10 MySQL database',
        '50 email accounts',
        'cPanel control panel',
        'Free SSL certificate',
        '24/7 support',
      ],
    },
    {
      title: 'PREMIUM',
      price: '$10',
      features: [
        'Unlimited domain name',
        '100 GB of disk space',
        '1TB of bandwidth',
        'Unlimited MySQL database',
        'Unlimited email accounts',
        'cPanel control panel',
        'Free SSL certificate',
        '24/7 priority support',
        'Advanced security features',
      ],
    },
  ];

  const pricingPanels = pricingData.map(pricing => (
    <PricingPanel
      key={pricing.title}
      title={pricing.title}
      price={pricing.price}
      features={pricing.features}
    />
  ));

  return (
    <div className='min-h-screen flex flex-col'>
      <Navbar />
      <main className='flex-grow'>
        <div className='bg-gray-1500'>
          <div className='max-w-screen-xl mx-auto px-4 py-12 sm:py-16 lg:py-24'>
            <div className='text-center'>
              <h2 className='text-3xl font-extrabold text-white sm:text-4xl lg:text-5xl'>Our Pricing Plans</h2>
              <p className='mt-4 text-lg text-gray-400'>Choose a plan that works for you.</p>
            </div>
            <div className='mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3'>
              {pricingPanels}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;